module.exports = __webpack_public_path__ + "static/media/instructor-onboarding-image20.72630449.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-onboarding-image20.png
// module id = 2588
// module chunks = 0